module.exports = __webpack_public_path__ + "static/media/4.ce9e51be.jpg";